// Substitua pelo seu TMDB API Key real
export const TMDB_API_KEY = '5173c8066086fe7c406c959303bd6cbf';
